// src/components/HabitRow.js

import React, { useState } from 'react';
import { FaCheckCircle, FaCircle } from 'react-icons/fa';
import StreakCelebration from './StreakCelebration';
import './HabitRow.css';
import * as Icons from 'react-icons/fa';

function HabitRow({ habit, onToggle, onRemove }) {
  const [clicked, setClicked] = useState(false);

  const progressText = `${habit.completedDays} out of ${habit.totalDays} days`;

  const progressPercentage =
    (habit.completedDays / habit.totalDays) * 100 || 0;

  const handleToggle = () => {
    setClicked(true);
    onToggle(habit.id);
    setTimeout(() => setClicked(false), 300);
  };

  // Get the icon component based on the icon name
  const HabitIcon = Icons[habit.icon] || FaCircle;

  return (
    <div className={`habit-row ${habit.completed ? 'habit-completed' : ''}`}>
      <div
        onClick={handleToggle}
        className={`habit-checkmark ${clicked ? 'clicked' : ''}`}
      >
        {habit.completed ? <FaCheckCircle color="#4caf50" /> : <FaCircle />}
      </div>
      <div className="habit-details">
        <div className="habit-icon">
          <HabitIcon />
        </div>
        <span className="habit-name">{habit.name}</span>
      </div>
      <div className="progress-text">{progressText}</div>
      <button onClick={() => onRemove(habit.id)} className="remove-button">
        X
      </button>

      {/* Progress Bar */}
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>

      {/* Streak Celebration */}
      <StreakCelebration streak={habit.streak} />
    </div>
  );
}

export default HabitRow;
